import React from 'react'
import { css } from 'aphrodite'
import { Table } from 'reactstrap'

import style from '../style'

import methodList from '../methods.json'

export const PaymentsTable = props => (
  <Table bordered responsive className={css(style.table.table)}>
    <thead>
      <tr>
        <th className={css(style.table.th)}>Methods</th>
        <th className={css(style.table.th, style.table.thCenter)}>Terms</th>
        <th className={css(style.table.th, style.table.thCenter)}>Fees</th>
      </tr>
    </thead>
    <tbody>
      {methodList.map((item, index) => (
        <RenderTableRow key={index} {...item} />
      ))}
    </tbody>
  </Table>
)

const RenderTableRow = props => (
  <tr className={css(style.table.tr)}>
    <td width={`60%`}>
      <img src={props.img} className={css(style.table.image)} />
      <span className={css(style.table.tdNameSpan)}> {props.name} </span>
    </td>
    <td align={'center'}>
      <span> {props.net} </span>
    </td>
    <td align={'center'}>
      <span> ${props.fee.toFixed(2)} </span>
    </td>
  </tr>
)

export default PaymentsTable



// WEBPACK FOOTER //
// ./src/components/Rates/partials/PaymentsTable.js